import { doHttp } from '../utils/common'
import http from '../utils/httpRequest'
import { HTTP_TYPE_GET, HTTP_TYPE_POST, CONTENT_TYPE_FORM } from '../utils/config'

/**
 * 产品打印统计
 * @param params
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiPrintReport (params, pageIndex = 1, pageSize = 20) {
  return doHttp(`/report/list.action?pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 产品扫描统计
 * @param params
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiScanReport (params, pageIndex = 1, pageSize = 20) {
  return doHttp(`/report/scan/list.action?pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 公司数据统计
 * @param params
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiDataReport (params, pageIndex = 1, pageSize = 20) {
  return doHttp(`/report/company/list.action?pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 产品打印统计导出
 * @param companyIds
 * @param startDate
 * @param endDate
 * @param query
 * @return {*}
 */
 export function apiPrintExcel (companyIds, startDate, endDate, query) {
  let params = {
    companyIds,
    startDate,
    endDate,
    query
  }
  // return doHttp(`/excel/print/list.action?companyIds=${companyIds}&startDate=${startDate}&endDate=${endDate}&query=${query}`, HTTP_TYPE_POST, {})
  startDate = startDate === null ? '' : startDate
  endDate = endDate === null ? '' : endDate
  if (companyIds.length !== 0) {
    companyIds = companyIds.toString()
  }
  let url = http.adornUrl(`/excel/print/list.action?startDate=${startDate}&endDate=${endDate}&companyIds=${companyIds}&query=${query}`)
  url = encodeURI(url)
  window.open(url)
}
